'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactPopper = require('react-popper');
var _reactOverlays = require('react-overlays');
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _popper = require('popper.js');
var _popper2 = _interopRequireDefault(_popper);
var _Menu = require('../Menu/Menu');
var _Menu2 = _interopRequireDefault(_Menu);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Dropdown wrapper to provide basic state management.
 */
var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);
  function Dropdown() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Dropdown);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.onClick = function (event) {
      _this.setState({
        open: !_this.state.open
      });
      event.preventDefault();
    }, _this.onChange = function () {
      _this.setState({
        open: true
      });
    }, _this.onKeyDown = function (event) {
      switch (event.keyCode) {
        case 40:
          // key down
          event.preventDefault();
          _this.refs['menu'].focus();
          break;
      }
    }, _this.onRootClose = function () {
      if (!_this.state.open) {
        return;
      }
      _this.setState({
        open: false
      });
    }, _this.onComputeStyle = function (data, options) {
      data = _popper2.default.Defaults.modifiers.computeStyle.fn(data, options);
      if (_this.props.autoSize) {
        data.styles.width = data.offsets.reference.width;
      }
      return data;
    }, _this.wrapOnSelect = function (existingOnSelect) {
      if (existingOnSelect) {
        var onClose = _this.onRootClose;
        return function (event) {
          onClose();
          existingOnSelect(event);
        };
      } else {
        return _this.onRootClose;
      }
    }, _this.render = function () {
      var popperPlacement = _this.props.variation ? _this.props.placement + '-' + _this.props.variation : _this.props.placement;
      var modifiers = {
        computeStyle: {
          fn: _this.onComputeStyle
        }
      };
      var child = _this.props.children;
      if (child.type === _Menu2.default) {
        child = _react2.default.cloneElement(child, {
          ref: 'menu',
          onSelect: _this.wrapOnSelect(child.props.onSelect)
        });
      }
      return _react2.default.createElement(_reactPopper.Manager, null, _react2.default.createElement(_reactPopper.Target, {
        id: _this.props.id
      }, _react2.default.createElement('div', {
        ref: _this.onSetRef,
        onClick: _this.onClickOutside
      }, _react2.default.cloneElement(_this.props.trigger, {
        onClick: _this.onClick,
        onChange: _this.onChange,
        onKeyDown: _this.onKeyDown
      }))), _this.state.open && _react2.default.createElement(_reactPopper.Popper, {
        placement: popperPlacement,
        className: 'popper',
        innerRef: _this.onSetPopperRef,
        style: dropdown,
        modifiers: modifiers
      }, _react2.default.createElement(_reactOverlays.RootCloseWrapper, {
        onRootClose: _this.onRootClose,
        disabled: !_this.state.open
      }, child)));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  return Dropdown;
}(_react.Component);
exports.default = Dropdown;
var dropdown = {
  zIndex: 1000
};
Dropdown.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Component that trigger the dropdown. (Typically a Button) */
  trigger: _propTypes2.default.node.isRequired,
  /** Placement of the dropdown */
  placement: _propTypes2.default.oneOf(['auto', 'top', 'right', 'bottom', 'left']),
  /** Each placement can have a variation from this list. Variations are interpreted easily if you think of them as the left to right written languages. Horizontally (top and bottom), start is left and end is right.
   Vertically (left and right), start is top and end is bottom. */
  variation: _propTypes2.default.oneOf(['start', 'end']),
  /** Automatically resize the popper to the same with as the trigger */
  autoSize: _propTypes2.default.bool,
  /** Children to display within the dropdown */
  children: _propTypes2.default.oneOfType([_propTypes2.default.node])
} : {};